import axios from 'axios';

const normalizeBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');
const configuredBaseUrl = normalizeBaseUrl(
    process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_BASE_URL
);
const apiBaseUrl = configuredBaseUrl;

if (!configuredBaseUrl) {
    throw new Error('Missing REACT_APP_BACKEND_URL for frontend API calls.');
}

if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(configuredBaseUrl) && process.env.NODE_ENV === 'production') {
    throw new Error('REACT_APP_BACKEND_URL cannot point to localhost in production.');
}

const buildUrl = (path) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    if (!apiBaseUrl) {
        throw new Error('API base URL is not configured.');
    }
    return `${apiBaseUrl}${normalizedPath}`;
};

const get = async (path) => {
    return await axios.get(buildUrl(path), getHeaders());
};

const post = async (path, data) => {
    try {
        return await axios.post(buildUrl(path), data, getHeaders());
    } catch (e) {
        //console.log('failed to post', e);
        throw e;
    }
};

const put = async (path, data) => {
    try {
        return await axios.put(buildUrl(path), data, getHeaders());
    } catch (e) {
        //console.log('failed to put', e);
        throw e;
    }
};

const del = async (path) => {
    try {
        return await axios.delete(buildUrl(path), getHeaders());
    } catch (e) {
        throw e;
    }
};

const getHeaders = () => {
    const user = JSON.parse(localStorage.getItem('user'));

    return {
        headers: {
            "Content-Type": "application/json",
            "token-header-key": user?.token,
      }
    };
};

export default {
    get,
    post,
    put,
    delete: del
};